import { Button } from '@mui/material';
import styled from 'styled-components';
import { LoadingButton } from '@shared/inputs/Buttons';
import { extraColor, muiTheme } from './muiTheme';

// All styled components related with Mui Button are moved here now.
// need to check inline style in buttons in other files.

export const CopyButton = styled(Button)`
  margin-top: 6px;
`;

export const DealsButton = styled(LoadingButton)({
  minHeight: 'auto',
  fontWeight: 600,
});

DealsButton.defaultProps = {
  variant: 'contained',
  size: 'small'
};

export const StyledSaveButton = styled(Button)<{ width?: string, minHeight?: string }>`
  width: ${({ width }) => width || '100px'};
  min-height: ${({minHeight}) => minHeight};
  background-color: ${extraColor.palette.green.main};
  opacity: 0.97;
  min-height: auto;
  &:hover {
    background-color: ${extraColor.palette.green.main};
    opacity: 1;
  }
`;

export const CancelButton = styled(Button)`
  opacity: 0.5;
  transition: opacity ease 0.3s;

  &:hover {
    opacity: 1;
  }
`;

export const SaveButtonWrapper = styled.div<{ top?: string; right?: string, position? : string }>`
  display: flex;
  align-items: center;
  gap: 15px;
  top: ${({ top }) => top || '-120px'};
  right: ${({ right }) => right || 0};
  position: ${({ position }) => position || 'absolute'};
`;

export const SaveButtonDisplayMsg = styled.span`
  font-size: 13px;
  color: ${muiTheme.palette.error.main};
  word-wrap: break-word;
`;

export const Tile = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  font-size: 13px;
  line-height: 1.2;
  font-weight: 600;
  flex-direction: column;
  text-align: center;
  padding: 11px 5px;
  width: 90px;
  gap: 6px;
  cursor: pointer;
  :hover {
  }
  svg {
    width: 30px;
  }
`;

Tile.defaultProps = {
  type: 'button',
  variant: 'contained',
  color: 'success',
};

export const StyledFileNameButton = styled(Button)`
  text-align: left;
  padding: 0;
  white-space: normal;
  word-break: break-word; 
  font-size: 13px;
  font-weight: bold;
`;
